<section class="incidencia-comment-modal" [formGroup]="formRegistro">
  <header class="incidencia-comment-modal__header">
    <div class="incidencia-comment-modal__title-block">
      <span class="incidencia-comment-modal__eyebrow">Incidencias QA</span>
      <h2>{{ data.titulo }}</h2>
      <p>Registra el comentario y adjunta evidencia relevante para la incidencia.</p>
    </div>

    <button
      type="button"
      mat-icon-button
      class="incidencia-comment-modal__close"
      (click)="onCloseClick()"
      aria-label="Cerrar modal"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="incidencia-comment-modal__body">
    <aside class="incidencia-comment-modal__summary">
      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Estatus</span>
        <strong class="incidencia-comment-modal__status">
          {{ data.dataKey.estatus }}
        </strong>
      </article>

      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Versión</span>
        <strong>{{ tituloVersion || "Sin versión" }}</strong>
      </article>

      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Archivos</span>
        <strong>{{ evidencia.length }}</strong>
        <span class="incidencia-comment-modal__summary-text">
          Adjunta capturas, documentos o videos de soporte.
        </span>
      </article>
    </aside>

    <div class="incidencia-comment-modal__content">
      <mat-form-field appearance="outline" class="incidencia-comment-modal__field">
        <mat-label>Descripción</mat-label>
        <textarea
          matInput
          aria-label="Descripción"
          rows="10"
          maxlength="2000"
          formControlName="descripcion"
          placeholder="Describe el comentario o la acción realizada"
        ></textarea>
      </mat-form-field>

      <section class="incidencia-comment-modal__evidence-panel">
        <div class="incidencia-comment-modal__panel-header">
          <div>
            <h3>Evidencias</h3>
            <p>Selecciona archivos para adjuntar al comentario.</p>
          </div>

          <div class="incidencia-comment-modal__panel-actions">
            <label class="app-form-btn app-form-btn--secondary app-form-btn--compact incidencia-comment-modal__action-trigger">
              Agregar
              <input
                type="file"
                id="nameFile"
                hidden
                multiple
                accept="image/*,application/*,audio/*,video/*"
                (change)="subirEv()"
              />
            </label>

            <button
              type="button"
              class="app-form-btn app-form-btn--secondary app-form-btn--compact"
              [disabled]="btnElimina"
              (click)="elimina()"
            >
              Remover
            </button>
          </div>
        </div>

        <mat-selection-list
          class="incidencia-comment-modal__file-list"
          formControlName="evidenciaSeleccionada"
          (selectionChange)="onEvidenciaChange()"
        >
          <mat-list-option
            *ngFor="let item of evidencia"
            [value]="item"
            class="incidencia-comment-modal__file-item"
          >
            <div class="incidencia-comment-modal__file-copy">
              <strong>{{ item.name }}</strong>
              <span>{{ item.size | number }} bytes</span>
            </div>
          </mat-list-option>
        </mat-selection-list>

        <p class="incidencia-comment-modal__empty" *ngIf="!evidencia.length">
          No hay archivos seleccionados.
        </p>
      </section>
    </div>
  </div>

  <footer class="incidencia-comment-modal__footer">
    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--secondary"
      (click)="onNoClick()"
    >
      Cancelar
    </button>

    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--primary"
      (click)="onSave()"
    >
      Guardar
    </button>
  </footer>
</section>
